import { Field } from 'formik';
import { Col, Form, Row, Stack } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../../components/forms';
import { StepProps } from '../AddEditRecipe';

export const RecipePreparationForm = ({
  touched,
  errors,
  values,
  setFieldValue,
  readOnly
}: StepProps) => {
  return (
    <Row>
      <Col xs={12}>
        <FormStepHeader title="Recipe Preparation" showRequiredLegend={false} />
      </Col>
      <Col xs={12}>
        <Stack gap={3}>
          <Form.Group controlId="recipe_steps_parent">
            <FormLabel>Family Method</FormLabel>
            <Field
              name="recipe_steps_parent"
              as="textarea"
              className="form-control"
              rows={4}
              isInvalid={touched.recipe_steps_parent && !!errors.recipe_steps_parent}
            />
            <Form.Text>
              <p>
                This will be broken up based on section headers, encapsulated by square brackets.
                Example:
                <br />
                [mix + match]
                <br />
                Do some stuff.
                <br />
                [bake]
                <br />
                Do some other stuff.
              </p>
            </Form.Text>
          </Form.Group>
          <Form.Group controlId="recipe_steps_instructor">
            <FormLabel>Chef Instructor Method</FormLabel>
            <Field
              name="recipe_steps_instructor"
              as="textarea"
              className="form-control"
              rows={4}
              isInvalid={touched.recipe_steps_instructor && !!errors.recipe_steps_instructor}
            />
            <Form.Text>
              <p>
                This will be broken up based on section headers, encapsulated by square brackets.
                Example:
                <br />
                [mix + match]
                <br />
                Do some stuff.
                <br />
                [bake]
                <br />
                Do some other stuff.
              </p>
            </Form.Text>
          </Form.Group>
        </Stack>
      </Col>
    </Row>
  );
};
